export const exteriorView08ImageOptions = {
	angle:"ExteriorView08",
	staticOptions:{
		HullColorways:1,
		Bowsprit:1,
		HullTreatment:1,
		TeakDeck:1,
		TeakOnSideDecks:1,
		BathingPlatform:1,
		SelfTacker:1,
		TeakOnCoachRoof:1,
		MastAndBoom:1,
		BoomCover:1,
		OutboardBracket:1,
		CockpitBenchExtentions:1,
		CockpitCushionBackrests:1,
		CockpitCushionSeats:1,
		CockpitFabric:1,
		SprayhoodFabric:1,
		GTSeat:1,
		Flag:1,
	},
	mattes:[
		{
			option:"HullColorways",
			dependency:null
		},
		{
			option:"HullTreatment",
			dependency:null
		},
		{
			option:"TeakDeck",
			dependency:"Wheel"
		},
		{
			option:"TeakOnSideDecks",
			dependency:["TeakDeck", "Wheel"]
		},
		{
			option:"SelfTacker",
			dependency:null
		},
		{
			option:"TeakOnCoachRoof",
			dependency:["TeakDeck", "SelfTacker"]
		},
		{
			option:"MastAndBoom",
			dependency:null
		},
		{
			option:"BoomCover",
			dependency:null
		},
		{
			option:"OutboardBracket",
			dependency:null
		},
		{
			option:"CockpitCushionBackrests",
			dependency:"CockpitFabric"
		},
		{
			option:"CockpitCushionSeats",
			dependency:["CockpitBenchExtentions", "CockpitFabric"]
		},
		{
			option:"CockpitFabric",
			dependency:null
		},
		{
			option:"SprayhoodFabric",
			dependency:"CockpitCushionBackrests"
		},
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/ExteriorView08.js